import React from 'react'
import {Button, Popover} from '@blueprintjs/core'
import SiteHeaderLoginStatusPop from './SiteHeaderLoginStatusPop'


export default function SiteHeaderLoginStatus({global, dispatch}) {

  if (!global.current_user_vuid) return null



  return (
    <Popover
      minimal={true}
      interactionKind='click'
      placement='bottom'
      inheritDarkTheme={false}
      content={<SiteHeaderLoginStatusPop global={global} dispatch={dispatch} />}
    >
      <div
        style={{
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'nowrap',
          alignItems: 'center',
          fontSize: '0.8rem',
        }}
      >
        {global.current_user_first_name}
        {' '}
        {global.current_user_last_name}

				&nbsp;


        <Button
          icon='user'
          minimal={true}
          small={true}
          outlined={false}
        />
      </div>
    </Popover>
  )
}
